import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material'
import PropTypes from 'prop-types'
import BoxBreadcrumbs from './BoxBreadcrumbs'
import BreadcrumbActive from './BreadcrumbActive'
import useBreadcrumbsStyles from './useBreadcrumbsStyles'

const BreadcrumbsSingle = ({ title }) => (
  <BoxBreadcrumbs mb={1}>
    <MuiBreadcrumbs aria-label="Kruimelpad" className={useBreadcrumbsStyles().breadcrumb}>
      <BreadcrumbActive title={title} />
    </MuiBreadcrumbs>
  </BoxBreadcrumbs>
)

BreadcrumbsSingle.propTypes = {
  title: PropTypes.string.isRequired,
}

export default BreadcrumbsSingle
